import { CircleTopicFragment } from '../../documents/topic.generated';

function getArrayOfUniqueElements<T>(array: readonly T[]): T[] {
  return [...new Set(array)];
}

export function getUniqueFacilitatorPhotos(
  topic: CircleTopicFragment,
  limit: number,
): readonly string[] {
  const photos = getArrayOfUniqueElements(
    topic?.sessions.edges.flatMap(
      item =>
        item?.node.facilitators.flatMap(facilitator => {
          return facilitator?.photo ?? [];
        }) ?? [],
    ),
  );

  return photos.slice(0, limit);
}
